/* eslint-disable import/no-anonymous-default-export */
export default {
    robb:'Qingping Indoor Environment Monitor',
    robb_banner_desc:'Accurate Monitoring{br}of 8 Metrics',
    robb_product_desc1:'PM2.5 · PM10 · CO2 · eTVOC · Noise · Light Level · Temp · RH',
    robb_product_desc2:'Wall-mounted · Multiple power supply methods',

    robb_product_desc_m_e_1:'PM2.5 · PM10 · CO2 · eTVOC{br}Noise · Light Level · Temp · RH',
    robb_product_desc_m_e_2:'Wall-mounted',
    robb_product_desc_m_e_3:'Multiple power supply methods',
    robb_step1_name: 'Qingping Indoor{br2}Environment{br}Monitor',
    robb_step1_desc: 'Wall-mounted{spot}8 metrics{spot} Multiple power supply methods{br}Replaceable PM sensor',
    robb_m_step1_desc_1: 'Wall-mounted',
    robb_m_step1_desc_2: '8 metrics',
    robb_m_step1_desc_3: ' Multiple power supply methods',
    robb_m_step1_desc_4: 'Replaceable PM sensor',
    robb_step2_name: 'With or Without Screen, as You Choose',
    robb_step2_card_title: 'E-Ink Screen Version',
    robb_step2_card_title2: 'Screenless Version',
    robb_step2_card_i_text1: 'Ultra-wide{br}viewing angle',
    robb_step2_card_i_text2: 'Ultra-high{br}contrast',
    robb_step2_card_i_text3: 'Multi-color{br}air quality{br}indicator{note}',
    robb_step2_card_i_text4: 'Button for{br}switching{br}readings',
    robb_step2_card_i_text5: 'Multi-color air{br}quality indicator{note}',
    robb_step2_card_i_text6: 'Button for checking{br}network status',

    robb_step3_name: '3 Power Supply Module Options',
    robb_step3_desc: 'The main body connects to the power supply module via a connector.',
    robb_step3_card_title1: 'Wall-Box AC Module',
    robb_step3_card_title2: 'Wall-Box Low-Volt Module',
    robb_step3_card_title3: 'Wall-Mounted Low-Volt Module', 
    
    robb_pop_wall_box_h1: 'Wall-Box AC Module',
    robb_pop_wall_box_h2: 'The product can replace the existing "86-type"* wall socket.',
    robb_pop_wall_box_tab_1_1: 'RS-485',
    robb_pop_wall_box_tab_2_1: '100-240V AC',
    robb_pop_wall_box_footer_text: '* The "86-type" is a widely used wall box standard (86 × 86 mm), compatible with wall boxes of the same size in China, Europe, and the UK.',

    robb_pop_wall_box_low_volt_h1: 'Wall-Box Low-Volt Module',
    robb_pop_wall_box_low_volt_h2: 'The product can replace the existing “86-type”* wall socket.',
    robb_pop_wall_box_low_volt_tab_1_1: 'RS-485',
    robb_pop_wall_box_low_volt_tab_2_1: '9-24V AC or 9–30V DC',
    robb_pop_wall_box_low_volt_footer_text: '* The "86-type" is a widely used wall box standard (86 × 86 mm), compatible with wall boxes of the same size in China, Europe, and the UK.',

    robb_pop_wall_mounted_h1: 'Wall-Mounted Low-Volt Module',
    robb_pop_wall_mounted_h2: 'Included in the package are a wall-mounting bracket, double-sided tape, and screws, allowing the Qingping Indoor Environment Monitor to be attached to a wall.',
    robb_pop_wall_mounted_tab_1_1: '9–24V AC or{br}9–30V DC',
    robb_pop_wall_mounted_tab_2_1: 'USB-C power port',
    robb_pop_wall_mounted_footer_text: 'Flexible wall-mounted design, suitable for various installation environments.',

    robb_step4_title: '3 Wireless Connectivity Options{note}',
    robb_step4_wifi: 'Wi-Fi network is required.',
    robb_step4_lora: 'LoRaWAN gateway or base station is required.',
    robb_step4_nbiot: 'CMCC NB-IoT{note} service is required.',

    robb_step5_title: 'Accurate Monitoring of 8 Metrics ',
    robb_step5_temp: "Temp & RH",
    robb_step5_co2: "CO2",
    robb_step5_pm25: "PM2.5 {br}& PM10",
    robb_step5_tvoc: "eTVOC{sup}",
    robb_step5_noise: "Noise",
    robb_step5_light: "Light Level",
    robb_step5_memo1:
    "Temperature and humidity are not only related to comfort, but also to health. Being in an environment with suboptimal temperature and humidity may cause sleep problems, even allergic reactions or respiratory diseases.",
    robb_step5_memo2:
    "High level CO2 would lead to drowsiness and usually indicate poor ventilation in the area, which also increases the risk of airborne virus infection.",
    robb_step5_memo3:
    "Fine dust particles such as PM2.5 and PM10, may infiltrate into our cardiovascular system and lead to serious health consequences. ",
    robb_step5_memo4:
    "TVOC refers to total volatile organic compounds, containing thousands of compounds. It may contain irritating gas, part of it may have negative effects on human health.",
    robb_step5_memo5:
    "Noise level has an impact on people's sleep quality and health. Constant noise may lead to insomnia, anxiety and increased stress. Prolonged exposure to excessive noise levels can cause hearing problems and may lead to deafness.",
    robb_step5_memo6: 'Too much or too little lighting can lead to eye fatigue, reducing study and work efficiency. Excessive use of lighting equipment may lead to energy waste.',
    robb_step6_name:'Replaceable PM Sensor, Easy for{br}Maintenance',
    robb_step6_desc:'The PM sensor is equipped with high-quality optical components and{br}a magnetic levitation fan, enabling fast response and reliability, and{br}providing accurate readings consistently.',

    robb_step7_title:'Works with{br}Qingping+ App{note}',
    robb_step7_desc:'You can use the Qingping+ App to manage{br}Qingping smart home devices, including{br}viewing data, modifying settings,{br}upgrading firmware, and more.',

    robb_step10_name:'Outstanding in Various Scenarios',
    robb_step10_desc:'It can be widely applied to various scenarios such as homes, schools, office{br}buildings, hospitals, restaurants, shopping malls, factories, hotels,{br}laboratories and so on.',
    robb_step10_banner1_footer:'Monitor the air quality, light and noise levels in offices and classrooms, and{br}take timely measures to provide a healthy and comfortable working and{br}studying environment.',
    robb_step10_banner2_footer:'Certain experiments, tests and production processes have strict{br}requirements on environmental temperature and humidity. Monitor{br}and record the temperature and humidity in laboratories and{br}factories to promptly address significant changes.',

    robb_step11_name:'Flame Resistance Material, Safe and{br}Durable',
    robb_step11_desc:'The housing material has excellent flame retardancy and insulation,{br}and is not easy to deform and fade.',

    robb_step12_1:'The multi-color air quality indicator shows the level of the indoor environment, with green for excellent, yellow for good, and red for bad. You can change the rating criteria for the readings through the Qingping IoT app or website.',
    robb_step12_2:'Support for customizing other wireless communication solutions, such as Thread, Zigbee, Cat-1, Cat-M, etc.',
    robb_step12_3:'NB-loT version includes a 6-year service plan of 50MB data usage per year. lt may vary in different batches.',
    robb_step12_4:'The TVOC sensor used in this product automatically adjusts the measurement baseline according to the data of the past period, so this product displays eTVOC (equivalent TVOC), which is not an accurate TVOC absolute value, and is only for users to observe the relative change trend of environmental TVOC concentration.',
    robb_step12_5:'Only the Wi-Fi version supports Qingping+.',

    // specifications
    robb_size:'Main body size',
    robb_color:'Color',
    robb_spec_size:'86 × 86 × 23 mm',
    robb_color:'White',

    robb_spec_long:'86 mm',
    robb_spec_short:'23 mm',
    robb_spec_height:'86 mm',

    robb_temp:'Temperature',
    robb_hum:'Humidity',
    robb_co2_range:'CO2',
    robb_pm_range:'PM2.5/PM10',
    robb_etvoc_range:'eTVOC',
    robb_noise_range:'Noise',
    robb_light_range:'Light level',
    
    robb_temperature_range:'ScreenLess version: -10 ~ 60°C{br}E-Ink screen version: 0 ~ 50°C   ',
    robb_humidity_range:'0 ~ 99%RH (no condensation){br}{hint}',
    robb_humidity_hint:'* Do not place this product in environment with humidity higher than 90% for long term use.',
    robb_co2_value:'400 ~ 9999 ppm',
    robb_pm_value:'0 ~ 999 μg/m³',
    robb_etvoc_value:'VOC Index 0 ~ 500, or 0.005 ~ 9.999 mg/m³',
    robb_noise_value:'36 ~ 95 dB',
    robb_light_value:'0 ~ 83000 lux',

    screen_resolution:'Screen resolution',
    robb_screen_resolution:'152 × 296 pixel',
    robb_weight:'113 g',
    robb_screen_size:'36 × 72 mm',
    robb_wifi:'Wi-Fi 2.4GHz or NB-IoT{br2}(CMCC) or LoRa',
    robb_ble:'Bluetooth 5.0',

    robb_package_name:'Main body',
    robb_package_battery:'PM sensor',
    robb_package_screen:'User manual',
    robb_package_screen_resolution:'Screwdriver{br}(only for{br}small screws)',
    robb_package_weight:'Small{br}screw × 2',

    robb_tab_1:'Wall-Box AC Module',
    robb_tab_2:'Wall-Box Low-Volt Module',   
    robb_tab_3:'Wall-Mounted Low-Volt Module',   
    robb_tab1_size:'82 × 82 × 33 mm',
    robb_tab1_color:'White',
    robb_tab1_left:'82 mm',
    robb_tab1_left2:'33 mm',
    robb_tab1_left3:'82 mm',
    wired_connect:'Wired Connectivity',
    input:'Input',
    robb_tab1_name:'Qingping Wall-Box AC Module',
    robb_tab1_weight:'62 g',
    robb_tab1_connect:'RS-485',
    robb_tab1_protect:'100–240V AC',
    robb_tab1_pack_7:'Qingping Wall-Box{br}{br2}AC Module',
    robb_tab1_pack_9:'Big screw × 4',
    robb_tab1_pack_10:'User manual',
    robb_tab2_name:'Qingping Wall-Box Low-Volt Module',
    robb_tab2_pack_7:'Qingping Wall-Box{br}{br2}Low-Volt Module',
    robb_tab2_protect:'9-24V AC or 9–30V DC',

    robb_tab3_size:'86 × 86 × 24 mm',
    robb_tab3_color:'White',
    robb_tab3_left:'86 mm',
    robb_tab3_left2:'24 mm',
    robb_tab3_left3:'86 mm',
    robb_tab3_name: 'Qingping Wall-Mounted Low-Volt Module',
    robb_tab3_weight: '57 g',
    robb_tab3_protect: '9–24V AC / 9–30V DC / USB-C (5V⎓1A)',
    robb_tab3_pack_7:'Qingping Wall-Mounted{br}Low-Volt Module',
    robb_tab3_pack_11:'Wall-mounting bracket',

    exterior_robb:'Design',
    specifications_robb:'Specs',
}